import {
  GET_LIMITS_REQUEST,
  GET_LIMITS_SUCCESS,
  GET_LIMITS_FAILURE,
  STATUS_CONFIG_LOADER_START,
  STATUS_CONFIG_LOADER_STOP,
  RESET_STATUS_CONFIG_STATE,
  UPDATE_LIMITS_REQUEST,
} from "./types";

export const startStatusConfigLoader = () => ({
  type: STATUS_CONFIG_LOADER_START,
});

export const stopStatusConfigLoader = () => ({
  type: STATUS_CONFIG_LOADER_STOP,
});

// Get Limits
export const getLimits = (payload) => ({
  type: GET_LIMITS_REQUEST,
  payload,
});

export const getLimitsSuccess = (data) => ({
  type: GET_LIMITS_SUCCESS,
  payload: data,
});

export const getLimitsFailure = (error) => ({
  type: GET_LIMITS_FAILURE,
  payload: error,
});

// Reset Status Configuration State
export const resetStatusConfigState = () => ({
  type: RESET_STATUS_CONFIG_STATE,
});

export const updateLimits = (payload) => ({
  type: UPDATE_LIMITS_REQUEST,
  payload,
});
